import css from "./Github.module.less"
import React from "react"
import { merge } from "../../helpers/arrayUtils"

interface IProps {
  className?: string
}

const componentName = "Github"
const debug = require("@wbe/debug")(`front:${componentName}`)

/**
 * @name Github
 */
function Github(props: IProps) {
  return (
    <svg
      className={merge([css.root, props.className])}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M17 1.48619e-06C26.3927 6.65053e-07 34 7.723 34 17.2585C34 25.3693 28.518 32.1008 21.122 33.9985C21.2073 33.7826 21.2493 33.48 21.2493 33.1789L21.2493 30.2443L23.3746 30.2443C24.522 30.2443 25.5854 29.7272 26.0527 28.7769C26.6054 27.7414 26.6907 26.1448 28.0927 25.1519C28.518 24.8067 28.178 24.4616 27.7107 24.5041C26.818 24.7627 26.0961 25.3678 25.4161 26.2726C24.7361 27.1788 24.438 27.3948 23.1634 27.3948C22.5688 27.3948 21.6341 27.3522 20.7834 27.2214C20.3161 26.0126 19.5088 24.9345 18.5307 24.4175C24.2254 23.7271 26.9454 20.8791 26.9454 16.9956C26.9454 15.3123 26.2234 13.7157 25.0327 12.3351C25.4146 10.997 25.9254 8.23561 24.862 7.15751C22.3112 7.15751 20.782 8.84076 20.4 9.27113C19.1254 8.8393 17.722 8.58079 16.278 8.58079C14.7907 8.58079 13.4307 8.8393 12.1561 9.27113C11.7741 8.8393 10.2434 7.15751 7.69412 7.15751C6.67413 8.19302 7.14144 10.997 7.56681 12.3351C6.37608 13.6731 5.69608 15.3123 5.69608 16.9956C5.69608 20.8791 8.37413 23.7271 14.0254 24.3308C12.4527 25.1504 11.3473 27.48 11.3473 29.2058L11.3473 33.1363C11.3473 33.2656 11.3893 33.3948 11.3893 33.5241C4.76 31.1946 -1.64577e-06 24.8097 -2.30591e-06 17.2585C-3.13953e-06 7.723 7.60732 2.30732e-06 17 1.48619e-06Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="34"
            height="34"
            fill="white"
            transform="matrix(-1 8.74228e-08 8.74228e-08 1 34 0)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Github
